import _regeneratorRuntime from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/Users/kevin/Projects/tradingblock/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .update-email-btn, .select-diff-phone-btn, .send-new-code-btn {\n    color: ", "\n  }\n\n  .form-group {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useEffect, useState } from 'react';
import useSWRMutation from 'swr/mutation';
import * as Yup from 'yup';
import styled from 'styled-components';
import { ResponseCodes, TwoFactorAuthenticationMethods } from '@tradingblock/types';
import PrimaryButton from '../components/PrimaryButton';
import { VerifyTwoFactorAuthenticationMethodUrl } from '@tradingblock/api';
import { Field, Form, Formik } from 'formik';
import { Loading } from '../../common';
import { TextboxField } from '../../localize/fields/Textbox';
import { ContextTypes } from '../TwoFactorAuthenticationSetup';
import { FormGroup } from '../../basic';
import { validateTwoFactorAuthenticationSecurityCode } from '../../../utilities';
var StyledEnterSecurityCode = styled.div(_templateObject(), function (params) {
  return params.context === ContextTypes.login ? 'white' : 'var(--blue)';
});
;

var EnterSecurityCode = function EnterSecurityCode(_ref) {
  var twoFactorAuthenticationMethodToBeVerified = _ref.twoFactorAuthenticationMethodToBeVerified,
      primaryButtonProps = _ref.primaryButtonProps,
      contactInfoToUseForTwoFactorAuthentication = _ref.contactInfoToUseForTwoFactorAuthentication,
      handleNextViewNavigation = _ref.handleNextViewNavigation,
      fallbackAuthTokenExpiredMsg = _ref.fallbackAuthTokenExpiredMsg,
      genericErrorMsg = _ref.genericErrorMsg,
      handleSelectDifferentPhoneNumber = _ref.handleSelectDifferentPhoneNumber,
      handleEmailUpdate = _ref.handleEmailUpdate,
      rootRestHubUrl = _ref.rootRestHubUrl,
      api = _ref.api,
      handleAuthTokenExpiration = _ref.handleAuthTokenExpiration,
      context = _ref.context,
      allowAbilityToCancel = _ref.allowAbilityToCancel,
      cancelBtnProps = _ref.cancelBtnProps,
      siteGrp = _ref.siteGrp;

  var _useSWRMutation = useSWRMutation("".concat(rootRestHubUrl, "/").concat(VerifyTwoFactorAuthenticationMethodUrl), function () {
    return api.twoFactorAuthentication.initiateSmsMethodVerification({
      twoFaType: twoFactorAuthenticationMethodToBeVerified,
      contact: contactInfoToUseForTwoFactorAuthentication.phoneNumber,
      siteId: siteGrp
    });
  }),
      initiateSmsTwoFactorAuthenticationMethodVerification = _useSWRMutation.trigger,
      errorInitiatingSmsTwoFactorAuthenticationMethodVerification = _useSWRMutation.error,
      initiatingSmsTwoFactorAuthenticationMethodVerification = _useSWRMutation.isMutating;

  var _useSWRMutation2 = useSWRMutation("".concat(rootRestHubUrl, "/").concat(VerifyTwoFactorAuthenticationMethodUrl), function () {
    return api.twoFactorAuthentication.initiateEmailMethodVerification({
      twoFaType: twoFactorAuthenticationMethodToBeVerified,
      contact: contactInfoToUseForTwoFactorAuthentication,
      siteId: siteGrp
    });
  }),
      initiateEmailTwoFactorAuthenticationMethodVerification = _useSWRMutation2.trigger,
      errorInitiatingEmailTwoFactorAuthenticationMethodVerification = _useSWRMutation2.error,
      initiatingEmailTwoFactorAuthenticationMethodVerification = _useSWRMutation2.isMutating;

  var _useSWRMutation3 = useSWRMutation("".concat(rootRestHubUrl, "/").concat(VerifyTwoFactorAuthenticationMethodUrl), function (_url, _ref2) {
    var arg = _ref2.arg;
    return api.twoFactorAuthentication.finalizeEmailMethodVerification({
      twoFaType: twoFactorAuthenticationMethodToBeVerified,
      contact: contactInfoToUseForTwoFactorAuthentication,
      twoFaSecurityCode: arg.twoFactorAuthenticationSecurityCode,
      siteId: siteGrp
    });
  }),
      finalizeEmailTwoFactorAuthenticationMethodVerification = _useSWRMutation3.trigger,
      errorFinalizingEmailTwoFactorAuthenticationMethodVerification = _useSWRMutation3.error,
      finalizingEmailTwoFactorAuthenticationMethodVerification = _useSWRMutation3.isMutating;

  var _useSWRMutation4 = useSWRMutation("".concat(rootRestHubUrl, "/").concat(VerifyTwoFactorAuthenticationMethodUrl), function (_url, _ref3) {
    var arg = _ref3.arg;
    return api.twoFactorAuthentication.finalizeSmsMethodVerification({
      twoFaType: twoFactorAuthenticationMethodToBeVerified,
      twoFaPhoneType: contactInfoToUseForTwoFactorAuthentication.type,
      plivoUuid: arg.plivoUuid,
      twoFaSecurityCode: arg.twoFactorAuthenticationSecurityCode,
      siteId: siteGrp
    });
  }),
      finalizeSmsTwoFactorAuthenticationMethodVerification = _useSWRMutation4.trigger,
      errorFinalizingSmsTwoFactorAuthenticationMethodVerification = _useSWRMutation4.error,
      finalizingSmsTwoFactorAuthenticationMethodVerification = _useSWRMutation4.isMutating;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      plivoUuid = _useState2[0],
      setPlivoUuid = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMsg = _useState4[0],
      setErrorMsg = _useState4[1];

  var issueSendingSecurityCodeErrorMsg = 'We encountered an issue sending the security code. Please click the button to request a new code. If the issue persists, please contact Customer Service.';
  var issueSubmittingSecurityCodeErrorMsg = 'There was an issue submitting the security code. Please click the button to request a new code. If the issue persists, please contact Customer Service.';
  var tooManyRequestsErrorMsg = 'You have exceeded the number of requests allowed. Please try again in a few minutes. If the issue persists, please contact Customer Service.';

  var requestSecurityCode =
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var responseCodeFromRequest, _ref5, responseCode, payload, _plivoUuid, _ref6, _responseCode;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setErrorMsg(null);
              responseCodeFromRequest = null;

              if (!(twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.sms)) {
                _context.next = 12;
                break;
              }

              _context.next = 5;
              return initiateSmsTwoFactorAuthenticationMethodVerification();

            case 5:
              _ref5 = _context.sent;
              responseCode = _ref5.responseCode;
              payload = _ref5.payload;
              responseCodeFromRequest = responseCode;

              if (responseCode === 0) {
                _plivoUuid = payload.plivoUuid;

                if (_plivoUuid) {
                  setPlivoUuid(_plivoUuid);
                } else {
                  setErrorMsg(issueSendingSecurityCodeErrorMsg);
                }
              }

              _context.next = 18;
              break;

            case 12:
              if (!(twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.email)) {
                _context.next = 18;
                break;
              }

              _context.next = 15;
              return initiateEmailTwoFactorAuthenticationMethodVerification();

            case 15:
              _ref6 = _context.sent;
              _responseCode = _ref6.responseCode;
              responseCodeFromRequest = _responseCode;

            case 18:
              if (responseCodeFromRequest !== 0) {
                if (responseCodeFromRequest === 200) {
                  if (handleAuthTokenExpiration) {
                    handleAuthTokenExpiration();
                  } else {
                    setErrorMsg(fallbackAuthTokenExpiredMsg);
                  }
                } else if (responseCodeFromRequest === 127 || responseCodeFromRequest === 143) {
                  setErrorMsg(ResponseCodes[responseCodeFromRequest].description);
                } else {
                  setErrorMsg(issueSendingSecurityCodeErrorMsg);
                }
              }

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestSecurityCode() {
      return _ref4.apply(this, arguments);
    };
  }();

  useEffect(function () {
    requestSecurityCode();
  }, []);
  useEffect(function () {
    if (errorFinalizingEmailTwoFactorAuthenticationMethodVerification || errorFinalizingSmsTwoFactorAuthenticationMethodVerification || errorInitiatingEmailTwoFactorAuthenticationMethodVerification || errorInitiatingSmsTwoFactorAuthenticationMethodVerification) {
      var responseCode = null;

      if (errorInitiatingEmailTwoFactorAuthenticationMethodVerification && errorInitiatingEmailTwoFactorAuthenticationMethodVerification.response) {
        responseCode = errorInitiatingEmailTwoFactorAuthenticationMethodVerification.response.status;
      } else if (errorInitiatingSmsTwoFactorAuthenticationMethodVerification && errorInitiatingSmsTwoFactorAuthenticationMethodVerification.response) {
        responseCode = errorInitiatingSmsTwoFactorAuthenticationMethodVerification.response.status;
      } else if (errorFinalizingEmailTwoFactorAuthenticationMethodVerification && errorFinalizingEmailTwoFactorAuthenticationMethodVerification.response) {
        responseCode = errorFinalizingEmailTwoFactorAuthenticationMethodVerification.response.status;
      } else if (errorFinalizingSmsTwoFactorAuthenticationMethodVerification && errorFinalizingSmsTwoFactorAuthenticationMethodVerification.response) {
        responseCode = errorFinalizingSmsTwoFactorAuthenticationMethodVerification.response.status;
      }

      if (responseCode === 429) {
        setErrorMsg(tooManyRequestsErrorMsg);
      } else {
        setErrorMsg(genericErrorMsg);
      }
    }
  }, [errorFinalizingEmailTwoFactorAuthenticationMethodVerification, errorFinalizingSmsTwoFactorAuthenticationMethodVerification, errorInitiatingEmailTwoFactorAuthenticationMethodVerification, errorInitiatingSmsTwoFactorAuthenticationMethodVerification]);

  var onSubmit =
  /*#__PURE__*/
  function () {
    var _ref7 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(values) {
      var responseCodeFromSubmitRequest, _ref8, responseCode, _ref9, _responseCode2;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setErrorMsg(null);
              responseCodeFromSubmitRequest = null;

              if (!(twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.email)) {
                _context2.next = 10;
                break;
              }

              _context2.next = 5;
              return finalizeEmailTwoFactorAuthenticationMethodVerification({
                twoFactorAuthenticationSecurityCode: values.securityCode
              });

            case 5:
              _ref8 = _context2.sent;
              responseCode = _ref8.responseCode;
              responseCodeFromSubmitRequest = responseCode;
              _context2.next = 16;
              break;

            case 10:
              if (!(twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.sms)) {
                _context2.next = 16;
                break;
              }

              _context2.next = 13;
              return finalizeSmsTwoFactorAuthenticationMethodVerification({
                twoFactorAuthenticationSecurityCode: values.securityCode,
                plivoUuid: plivoUuid
              });

            case 13:
              _ref9 = _context2.sent;
              _responseCode2 = _ref9.responseCode;
              responseCodeFromSubmitRequest = _responseCode2;

            case 16:
              if (responseCodeFromSubmitRequest === 0) {
                handleNextViewNavigation();
              }

              if (responseCodeFromSubmitRequest !== 0) {
                if (responseCodeFromSubmitRequest === 200) {
                  if (handleAuthTokenExpiration) {
                    handleAuthTokenExpiration();
                  } else {
                    setErrorMsg(fallbackAuthTokenExpiredMsg);
                  }
                } else {
                  if (responseCodeFromSubmitRequest === 129 || responseCodeFromSubmitRequest === 131 || responseCodeFromSubmitRequest === 127) {
                    setErrorMsg(ResponseCodes[responseCodeFromSubmitRequest].description);
                  } else {
                    setErrorMsg(issueSubmittingSecurityCodeErrorMsg);
                  }
                }
              }

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x) {
      return _ref7.apply(this, arguments);
    };
  }();

  return React.createElement(StyledEnterSecurityCode, {
    context: context
  }, (finalizingEmailTwoFactorAuthenticationMethodVerification || finalizingSmsTwoFactorAuthenticationMethodVerification || initiatingEmailTwoFactorAuthenticationMethodVerification || initiatingSmsTwoFactorAuthenticationMethodVerification) && React.createElement("div", {
    className: "loading-container"
  }, React.createElement(Loading, null)), !finalizingEmailTwoFactorAuthenticationMethodVerification && !finalizingSmsTwoFactorAuthenticationMethodVerification && !initiatingEmailTwoFactorAuthenticationMethodVerification && !initiatingSmsTwoFactorAuthenticationMethodVerification && React.createElement(React.Fragment, null, React.createElement("p", null, "We sent a security code to ", twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.sms ? contactInfoToUseForTwoFactorAuthentication.phoneNumber : contactInfoToUseForTwoFactorAuthentication, "."), React.createElement(Formik, {
    validateOnChange: true,
    validationSchema: Yup.object().shape({
      securityCode: Yup.string().trim().test('validityCheck', 'Please enter a valid security code.', function (securityCodeString) {
        return validateTwoFactorAuthenticationSecurityCode(securityCodeString);
      })
    }),
    onSubmit: onSubmit,
    initialValues: {
      securityCode: ''
    }
  }, React.createElement(Form, {
    translate: undefined
  }, React.createElement(FormGroup, null, React.createElement(Field, {
    component: TextboxField,
    id: "securityCode"
  })), React.createElement("div", {
    className: "mt-1"
  }, React.createElement("button", {
    type: "button",
    className: "send-new-code-btn",
    onClick: requestSecurityCode
  }, "Resend code"), React.createElement("span", {
    className: "ml-1 mr-1"
  }, "|"), twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.sms && React.createElement("button", {
    type: "button",
    className: "select-diff-phone-btn",
    onClick: handleSelectDifferentPhoneNumber
  }, "Change phone number"), twoFactorAuthenticationMethodToBeVerified === TwoFactorAuthenticationMethods.email && React.createElement("button", {
    type: "button",
    className: "update-email-btn",
    onClick: handleEmailUpdate
  }, "Change email")), React.createElement("div", {
    className: "btn-wrapper"
  }, allowAbilityToCancel && cancelBtnProps && React.createElement("button", Object.assign({
    type: "button"
  }, Object.assign({}, cancelBtnProps, {
    className: "".concat(cancelBtnProps.className ? cancelBtnProps.className : '', " mr-3")
  })), "Cancel"), React.createElement(PrimaryButton, Object.assign({}, primaryButtonProps, {
    primaryBtnClassName: "".concat(primaryButtonProps.primaryBtnClassName, " mb-3 mt-3")
  }))))), errorMsg && React.createElement("p", {
    className: "error"
  }, errorMsg)));
};

export default EnterSecurityCode;